import './BottomSheetMenu/bottom-sheet-menu.scss';

import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BiMenuAltLeft } from 'react-icons/bi';
import { MdClose } from 'react-icons/md';

import CartLink from '@/resources/components/navbar/CartLink';
import PrivacyPolicyPopup from '@/resources/components/privacyPolicyPopup/PrivacyPolicyPopup';
import { useDevice } from '@/resources/hooks/useDevice';
import { usePageBreakpoints } from '@/resources/hooks/usePageBreakpoints';
import { useTextColor } from '@/resources/hooks/useTextColor';

import { useNavbarContext } from '../../../../hooks/useNavbarContext';
import { useWebContext } from '../../../../hooks/useWebContext';
import Logo from '../../../navbar/logo/Logo';
import SearchInput from '../../../navbar/SearchInput';
import SearchLink from '../../../navbar/SearchLink';
import DefaultStore from '../../../navbar/stores/DefaultStore';
import BottomSheetMenu from './BottomSheetMenu';

function Mobile() {
  const { order, configs } = useWebContext();
  const { device } = useDevice();
  const { pathname } = useNavbarContext();
  const { breakpoints } = usePageBreakpoints();
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const textColor = useTextColor(
    device === 'desktop' ? configs.navbar_footer_color : configs.color,
  );

  return (
    <div className="d-flex flex-column d-md-none align-self-stretch w-100">
      <div style={{ backgroundColor: configs.color }}>
        <Container className="d-flex justify-content-center p-0" fluid>
          <Row className="justify-content-center w-100 py-2">
            <Col {...breakpoints} className="px-lg-0 d-flex flex-column">
              <div className="d-flex align-items-center justify-content-between mobile-navbar-header">
                <button
                  className="btn btn-link p-0 m-0 mobile-navbar-menu-btn"
                  onClick={() => setShowBottomSheet(true)}
                  aria-label="Abrir categorias"
                >
                  {!showBottomSheet && <BiMenuAltLeft size="40" color={textColor} />}
                </button>

                <div
                  className={`mobile-navbar-logo-anim ${showBottomSheet ? 'logo-animated' : ''}`}
                >
                  <Logo style={{ maxWidth: '150px' }} onClose={() => setShowBottomSheet(false)} />
                </div>
                <div className="mobile-navbar-cart-close-wrapper">
                  <div
                    className={`mobile-navbar-cart${
                      showBottomSheet ? ' mobile-navbar-hidden' : ''
                    }`}
                  >
                    <CartLink size="30" />
                  </div>
                  <div
                    className={`mobile-navbar-close${
                      showBottomSheet ? ' mobile-navbar-visible' : ''
                    }`}
                  >
                    <div onClick={() => setShowBottomSheet(false)}>
                      <MdClose color={textColor} size="40" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`d-flex align-items-center position-relative w-100 mt-2 mobile-navbar-search${
                  showBottomSheet ? ' mobile-navbar-hidden' : ''
                }`}
              >
                {pathname.includes('/search') ? <SearchInput /> : <SearchLink />}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div
        className="d-flex align-items-center p-1"
        style={{ backgroundColor: configs.navbar_footer_color }}
      >
        <DefaultStore />
      </div>

      {order && <PrivacyPolicyPopup />}

      <BottomSheetMenu open={showBottomSheet} onClose={() => setShowBottomSheet(false)} />
    </div>
  );
}

export default Mobile;
